import React from 'react';
import { Col, Row, Panel, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';

const ScanOverridesSearch = props => (
  <Panel>
    <Row>
      <Col md={12}>
        <FormGroup>
          <FormControl
            onChange={props.onInputChange}
            placeholder="Search by id, customer number, user id, product code (ean), outer code..."
            value={props.searchValue}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <FormGroup>
          Status
          <FormControl
            value={props.overrideRequestStatus}
            onChange={props.onStatusChange}
            componentClass="select"
          >
            <option>All</option>
            {props.overrideRequestStatuses &&
              props.overrideRequestStatuses.map((status, index) => <option key={index} value={status}>{status}</option>)}
          </FormControl>
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          Request date from
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateFromValue}
            onChange={props.onDateFromChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date from'
            }}
          />
        </FormGroup>
      </Col>
      <Col md={3}>
        <FormGroup>
          Request date to
          <DateTime
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={props.dateToValue}
            onChange={props.onDateToChange}
            closeOnSelect
            inputProps={{
              placeholder: 'Date to'
            }}
          />
        </FormGroup>
      </Col>
      <Col md={3} className="actions" style={{marginTop: '20px'}}>
        <Button
          className="red-ghost-btn"
          onClick={props.onSearch}
        >Search
        </Button>
        <Button
          className="red-ghost-btn"
          onClick={props.onClear}
        >Clear search
        </Button>
      </Col>
    </Row>
  </Panel>
);

export default ScanOverridesSearch;



// WEBPACK FOOTER //
// ./src/components/admin/scans/scan-overrides/scan-override-search.jsx